import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import classnames from 'classnames';
import Signup from 'hostedFreePages/Signup';
import Onboarding from 'hostedFreePages/Onboarding';
import { useGlobalState } from 'hooks/useGlobalState';
import { useMunchkinTracking } from 'hooks/useMunchkinTracking';
import styles from './PageContent.module.scss';

export default function PageContent() {
  const [{ signup, waitingScreen, timeoutScreen }] = useGlobalState();
  useMunchkinTracking();

  return (
    <div
      className={classnames(styles.contentContainer, {
        [styles.noScroll]: waitingScreen.visible || timeoutScreen.visible,
      })}
    >
      <Routes>
        <Route exact path="/" element={<Signup />} />
        <Route
          path="/onboarding"
          element={signup.status ? <Onboarding /> : <Navigate to="/" />}
        />
      </Routes>
    </div>
  );
}
